/** 초안 이어쓰기(비파괴) — 기존 본문이 있으면 빈 줄 하나로 잇는다. 캔버스·카드의 '반영' 공용 규칙. */
export function appendDraftBody(current: string, addition: string): string {
  const add = addition.trim();
  if (!add) return current;
  const cur = current.trim() ? current.replace(/\s+$/, '') : '';
  return cur ? `${cur}\n\n${add}` : add;
}
